export const ConvertNumberToCurrencyStr = (number, prefix) => {
  return number
    ? `${prefix}${number.toLocaleString("us", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })}`
    : `${prefix}0.00`;
};
